
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './present-continuous-explanation';
const mainimage = '/Images/extremeweather1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "presentcontinuous" },
];

const PresentContinuous = () => (
  <GrammarPageLayout
    level="A1"
    title="Present Continuous"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Present Continuous Exercises"
    seoDescription="Practice the present continuous tense for actions happening now or around the moment of speaking. A1 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="A1"
  />
);

export default PresentContinuous;

